import React from 'react';

const BrandMark = ({ className = "w-8 h-8", color = "text-rocket-500" }) => (
  <div className={`${className} ${color} relative flex items-center justify-center`}>
    <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[0_0_8px_rgba(249,115,22,0.4)]">
      {/* Abstract Launch Layers */}
      <path 
        d="M20 75 L50 90 L80 75 L50 60 Z" 
        fill="currentColor" 
        fillOpacity="0.1" 
      />
      <path 
        d="M20 55 L50 70 L80 55 L50 40 Z" 
        fill="currentColor" 
        fillOpacity="0.3" 
      />
      <path 
        d="M20 35 L50 50 L80 35 L50 20 Z" 
        fill="currentColor" 
      />
      {/* Ignition Core */}
      <rect x="48" y="15" width="4" height="45" rx="2" fill="#fff" className="animate-pulse" />
      <circle cx="50" cy="15" r="3" fill="#fff" className="animate-pulse" />
    </svg>
  </div>
);

export default BrandMark;